/* eslint-disable max-lines-per-function */
import { CopyToClipboard } from '@/components';
import { Card, CardContent } from '@/components/ui/card';
import { KalenderCardActions } from '@/domain/termine/features/TerminKalender/Mobile/Card/KalenderCardActions';
import { ColorDot } from '@/domain/termine/components/ColorPicker/ColorDot';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { markierungMapper } from '@/domain/termine/shared/types/Markierung';
import { useTranslation } from 'react-i18next';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type KalenderCardProps = {
  kalender: TerminKalender;
  onDelete?: (kalenderId: string) => void;
};

export function KalenderCard({ kalender, onDelete }: KalenderCardProps) {
  const { t } = useTranslation();

  return (
    <Card className="bg-white border-neutrals-300 shadow-xs text-sm">
      <CardContent className="p-4 space-y-3">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <ColorDot
              color={
                kalender.markierung
                  ? markierungMapper[kalender.markierung]?.base
                  : '#ccc'
              }
              className="w-2.5 h-2.5"
            />
            <span className="text-sm font-medium text-neutrals-900">
              {kalender.name}
            </span>
          </div>
        </div>
        <div className="space-y-1">
          <span className="text-xs text-neutrals-700">
            {t('domain.termine.kalender.table.apiKey')}
          </span>
          <Popover>
            <PopoverTrigger asChild>
              <button
                type="button"
                aria-label={t('domain.termine.kalender.table.apiKeyTooltip')}
                onClick={(e) => e.stopPropagation()}>
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  className="text-neutrals-700 px-1 cursor-pointer rounded-md w-4 h-4"
                />
              </button>
            </PopoverTrigger>
            <PopoverContent
              side="bottom"
              className="w-64 p-3 text-xs text-neutrals-900 wrap-break-word whitespace-normal">
              {t('domain.termine.kalender.table.apiKeyTooltip')}
            </PopoverContent>
          </Popover>
          <CopyToClipboard
            variant="ghost"
            size="sm"
            value={String(kalender.kalenderSchluessel ?? '')}
          />
        </div>
      </CardContent>

      <KalenderCardActions kalenderId={kalender.id} onDelete={onDelete} />
    </Card>
  );
}
